import { tr as __tr, useLocale as __useLocale } from "./i18n/runtime";
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminDashboard from "./pages/AdminDashboard";
import CustomerDashboard from "./pages/CustomerDashboard";
import CheckoutPage from './pages/CheckoutPage';

// Protected Route Component
const ProtectedRoute = ({
  children,
  allowedRoles
}) => {
  __useLocale();
  const {
    user,
    loading,
    isAuthenticated
  } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6B5B95]"></div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};
function AppRoutes() {
  __useLocale();
  const {
    user,
    isAuthenticated
  } = useAuth();
  return <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/register" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />} />
      <Route path="/dashboard" element={<ProtectedRoute>
            {__tr(user?.role === 'admin' || user?.role === 'staff' ? <Navigate to="/admin" replace /> : <CustomerDashboard />)}
          </ProtectedRoute>} />
      <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['admin', 'staff']}>
            <AdminDashboard />
          </ProtectedRoute>} />
    </Routes>;
}
function App() {
  __useLocale();
  return <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>;
}
export default App;
